<template>
    <div id="product-edit-form">
        <b-loading :active="loading"/>
        <top-section
            v-if="!product['removed_on'] && !loading">
            {{ __('strings.product.form.title') }}
            <template v-slot:buttons>
                <b-button tag="button"
                          type="is-primary"
                          class="is-uppercase"
                          label="Sync Atelier"
                          rounded
                          style="margin-right: 10px;"
                          @click.prevent="syncAtelier"
                          outlined/>

                <b-button tag="button"
                          type="is-primary"
                          class="is-uppercase"
                          label="Export Images"
                          rounded
                          style="margin-right: 10px;"
                          @click.prevent="exportProductImages"
                          outlined/>

                <b-button tag="button"
                          type="is-primary"
                          class="is-uppercase"
                          label="Export Product"
                          rounded
                          style="margin-right: 10px;"
                          @click.prevent="exportProduct"
                          outlined/>

                <b-button tag="button"
                          type="is-primary"
                          class="is-uppercase"
                          label="Save Product"
                          rounded @click.prevent="submit"
                          outlined/>
            </template>

        </top-section>

        <h3
            v-if="!loading && product['removed_on']"
            class="product-removed-on title is-3">
            SKU {{ product['sku'] }} removed on: {{ product['removed_on'] }}
        </h3>

        <div v-if="!product['removed_on'] && !loading">
            <store-switcher route-name="product.edit.store" :route-params="routeParams"/>

            <product-attributes-section :product="product" v-model="input"/>
            <product-price-section :product="product"/>
            <product-stock-section :product="product"/>
            <product-categories-section :product="product"/>
            <product-brand-section :product="product"/>
            <product-season-section :product="product"/>
            <product-gender-section :product="product"/>

            <div class="section is-flex">
                <b-button
                    tag="button"
                    type="is-primary"
                    class="is-uppercase"
                    label="Save Product"
                    rounded style="margin-left: auto"
                    @click.prevent="submit"
                    outlined/>
            </div>
        </div>

        <portal to="sidebar">
            <p class="menu-label mt-4">Product Image Gallery</p>
            <img v-for="media in product.media" :key="`product-media-${media.id}`" :src="media.url">
        </portal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            product: {},
            input: {}
        }
    },
    mounted() {
        this.fetchProduct();
    },
    methods: {
        fetchProduct() {
            if (this.$route.params.hasOwnProperty('id') && this.$route.params.id) {
                let params = {};
                if (this.$route.params.hasOwnProperty('store')) {
                    params = {store: this.$route.params.store}
                }
                this.loading = true;
                axios.get('/product/edit/' + this.$route.params.id, {params})
                    .then(response => {
                        this.product = {
                            ...response.data,
                            media: response.data.media.sort((a, b) => {
                                return a.order - b.order;
                            })
                        }
                        this.input = Object.assign({}, response.data)
                        this.loading = false;
                    })
            }
        },
        submit() {
            this.loading = true
            let toSend = {}
            for (let key of Object.keys(this.input)) {
                if (this.product[key] !== this.input[key]) {
                    toSend[key] = this.input[key];
                }
            }

            toSend['store'] = this.$route.params.hasOwnProperty('store')
                ? this.$route.params.store
                : 1;

            axios.patch(`/update/product/${this.product.id}`, toSend)
                .then(response => {
                    this.product = response.data
                    this.loading = false
                    this.toaster("Product correctly updated", "is-success")
                })
                .catch(error => {
                    this.toaster("There was an error with your request", "is-danger")
                })
        },
        exportProductImages(){
          this.loading = true;
            this.loading = true
            axios.post(`/export/product-images`, {productId: this.product.id})
                .then(response => {
                    this.loading = false
                    this.toaster("The image export request has been sent", "is-success")
                })
                .catch(error => {
                    this.loading = false
                    this.toaster("There was an error with your request", "is-danger")
                })
        },
        exportProduct() {
            this.loading = true
            axios.post(`/export/product`, {productId: this.product.id})
                .then(response => {
                    this.loading = false
                    this.toaster("Product correctly exported", "is-success")
                })
                .catch(error => {
                    this.loading = false
                    this.toaster("There was an error with your request", "is-danger")
                })
        },
        syncAtelier(){
            this.loading = true;
            this.loading = true
            axios.get(`/product/sync-atelier?id=${this.product.id}`)
                .then(response => {
                    this.loading = false
                    this.toaster("The sync request has been sent", "is-success")
                })
                .catch(error => {
                    this.loading = false
                    this.toaster("There was an error with your request", "is-danger")
                })
        },
        toaster(message, type) {
            this.$buefy.snackbar.open({
                message,
                type,
                position: 'is-bottom-right',
                actionText: 'Ok',
            })
        }
    },
    computed: {
        routeParams() {
            return {
                id: this.product.id
            }
        }
    },
    watch: {
        $route() {
            this.fetchProduct();
        }
    }
}
</script>
